export default __webpack_public_path__ + "static/media/404.284ee408.png";